import React, { useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";

const MessageQuill = (props) => {
    return (
        <div>
            <textarea
                className="border-gray border-[1px] w-full pt-5 bg-white-dark placeholder-gray text-[1.5rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] focus:border-2 outline-none overflow-hidden"
                name="test"
                id=""
                cols="20"
                rows="7"
                value={props.value}
                onChange={(e) => props.setValue(e.target.value)}
                placeholder={props.placeholder}
            />
        </div>
    );
};

export default MessageQuill;
